import { FunctionComponent } from 'react';

import BaseLayout from './base';
import MainLayout from './main';
import TabsLayout, { LinkingTabLayout } from './tabs';

type LayoutProps = FunctionComponent & {
  Main: typeof MainLayout;
  Tabs: typeof TabsLayout;
  LinkingTabs: typeof LinkingTabLayout;
};

// eslint-disable-next-line react/prop-types
const Layout: LayoutProps = ({ children }) => (
  <BaseLayout>{children}</BaseLayout>
);

Layout.Main = MainLayout;
Layout.Tabs = TabsLayout;
Layout.LinkingTabs = LinkingTabLayout;

export default Layout;
